module.exports = __webpack_public_path__ + "img/award-btn-claim.c40b6c7b.png";